// extracted by mini-css-extract-plugin
export default {"container":"style_container__u2jxL","chatPlaceholder":"style_chatPlaceholder__nhAz5"};